import { render, staticRenderFns } from "./BluePrintEdit.vue?vue&type=template&id=04c85825&scoped=true&"
import script from "./BluePrintEdit.vue?vue&type=script&lang=js&"
export * from "./BluePrintEdit.vue?vue&type=script&lang=js&"
import style0 from "./BluePrintEdit.vue?vue&type=style&index=0&id=04c85825&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c85825",
  null
  
)

export default component.exports